import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, getColorTint, unit, unitTRBL } from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import View from '@zego/components/atoms/View';
import CarouselTestimonials from '@zego/components/molecules/CarouselTestimonials';

const Container = styled(View)({
  color: getColorTint('grey', 10),
  padding: unitTRBL(6, 2, 0, 2),

  [BREAKPOINTS.medium]: {
    padding: unitTRBL(6, 0, 5, 0),
  },
});

const CentredHeading = styled(H2)({
  textAlign: 'center',
  color: getColorTint('grey', 10),
  display: 'none',

  [BREAKPOINTS.medium]: {
    display: 'block',
    paddingTop: unit(5),
    paddingBottom: unit(10),
  },
});

export interface Testimonial {
  id: string;
  image: string;
  alt: string;
  text: string;
  customer: string;
}

interface MultipleTestimonialsSectionProps {
  heading: string;
  testimonials: Testimonial[];
}

export default function MultipleTestimonialsSection({
  heading,
  testimonials,
}: MultipleTestimonialsSectionProps): JSX.Element {
  return (
    <Container>
      <CentredHeading>{heading}</CentredHeading>
      <CarouselTestimonials items={testimonials} />
    </Container>
  );
}
